// здесь будут отражаться финансовые показатели компании за конкретный период
//frontend/src/components/FinanceReport/FinanceOverview.jsx

import { useEffect, useMemo, useState } from "react";
import { authFetch } from "../api/api";
const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

function getYearRange() {
  const now = new Date();
  const year = now.getFullYear();

  return {
    startOfYear: `${year}-01-01`,
    endOfYear: `${year}-12-31`,
  };
}

function getRangeByMode(mode) {
  const now = new Date();
  const year = now.getFullYear();

  switch (mode) {
    case "1m": {
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return {
        start: `${year}-${month}-01`,
        end: `${year}-${month}-${day}`,
      };
    }

    case "3m":
      return { start: `${year}-01-01`, end: `${year}-03-31` };

    case "6m":
      return { start: `${year}-01-01`, end: `${year}-06-30` };

    case "9m":
      return { start: `${year}-01-01`, end: `${year}-09-30` };

    case "1y":
      return { start: `${year}-01-01`, end: `${year}-12-31` };

    default:
      return getYearRange();
  }
}

export default function FinanceOverview() {
  const [mode, setMode] = useState("1m");
  const [customRange, setCustomRange] = useState({
    start: "",
    end: "",
  });

  const [data, setData] = useState({
    income_cny: 0,
    expense_cny: 0,
    profit_cny: 0,
  });

  const range = useMemo(() => {
    if (mode === "custom") return customRange;
    return getRangeByMode(mode);
  }, [mode, customRange]);

  const fetchData = async () => {
    if (!range.start || !range.end) return;

    try {
      const res = await authFetch(
        `${BASE_URL}/api/finances/profit/total/?start_date=${range.start}&end_date=${range.end}`
      );
      
      if (!res.ok) throw new Error("Ошибка загрузки");
      const result = await res.json();
      setData(result);
    } catch (error) {
      console.error("Ошибка финансов:", error);
    }
  };  

  useEffect(() => {
    fetchData();
  }, [range]);

  const isProfit = data.profit_cny >= 0;

  return (
    <div style={{ padding: 20 }}>
      <h2>Финансовые показатели</h2>

      {/* ПЕРИОДЫ */}
      <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <button onClick={() => setMode("1m")}>текущий месяц</button>
        <button onClick={() => setMode("3m")}>3 месяца</button>
        <button onClick={() => setMode("6m")}>6 месяцев</button>
        <button onClick={() => setMode("9m")}>9 месяцев</button>
        <button onClick={() => setMode("1y")}>1 год</button>
        <button onClick={() => setMode("custom")}>произвольный</button>
      </div>

      {/* КАСТОМНЫЙ ДИАПАЗОН */}
      {mode === "custom" && (
        <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
          <input
            type="date"
            value={customRange.start}
            onChange={(e) =>
              setCustomRange((p) => ({
                ...p,
                start: e.target.value,
              }))
            }
          />
          <input
            type="date"
            value={customRange.end}
            onChange={(e) =>
              setCustomRange((p) => ({
                ...p,
                end: e.target.value,
              }))
            }
          />
        </div>
      )}

      {/* ПОКАЗ ВЫБРАННОГО ДИАПАЗОНА */}
      <p style={{ marginTop: 10, color: "#666" }}>
        {range.start} → {range.end}
      </p>

      {/* КАРТОЧКИ */}
      <div style={{ marginTop: 30, display: "grid", gap: 15 }}>
        <div style={{ padding: 15, border: "1px solid #ddd" }}>
          <h4>Доход</h4>
          <p>{data.income_cny} CNY</p>
        </div>

        <div style={{ padding: 15, border: "1px solid #ddd" }}>
          <h4>Расход</h4>
          <p>{data.expense_cny} CNY</p>
        </div>

        <div
          style={{
            padding: 15,
            border: "1px solid #ddd",
            background: isProfit ? "#e6ffed" : "#ffe6e6",
          }}
        >
          <h4>Прибыль</h4>
          <p style={{ color: isProfit ? "green" : "red", fontSize: 20 }}>
            {data.profit_cny} CNY
          </p>
        </div>
      </div>
    </div>
  );
}